import { render } from "./SloganLine.vue?vue&type=template&id=6882a387&scoped=true"
import script from "./SloganLine.vue?vue&type=script&lang=js"
export * from "./SloganLine.vue?vue&type=script&lang=js"

import "./SloganLine.vue?vue&type=style&index=0&id=6882a387&scoped=true&lang=css"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6882a387"]])

export default __exports__